import { render, staticRenderFns } from "./CustomSnackBar.vue?vue&type=template&id=040e1f0e&scoped=true&"
import script from "./CustomSnackBar.vue?vue&type=script&lang=ts&"
export * from "./CustomSnackBar.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSnackBar.vue?vue&type=style&index=0&id=040e1f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e1f0e",
  null
  
)

export default component.exports